import request from '@/http'

// const interceptors=(url, method,data)=>{
// 	request({
// 		url,
// 		method,
// 		data
// 	}).then(res=>{
		
// 		return res.data
// 	})
// }
//监控设备列表
export function watchList(params) {

    return request({
        url: 'wmsapp-service/warehouse/equipment/bank/granary/monitor/tree',
        method: 'post',
        data: params
    })
}
//获取萤石云的播放地址
export function ezvizUrl(params) {

    return request({
        url: 'ffsapp-service/ezviz/getPlayUrl',
        method: 'post',
        data: params
    })
}


//银行大屏-监控设备列表
export function deviceList(params) {

    return request({
        url: 'ffsapp-service/offlineVideo/allVideoList',
        method: 'post',
        data: params
    })
}

//银行大屏-监控设备-获取萤石云
export function getPlayEzvizUrl(params) {

    return request({
        url: 'ffsapp-service/ezviz/getPlayUrl',
        method: 'post',
        data: params
    })
}


//银行大屏-监控设备-获取国标
export function getPlayUrl(params) {

    return request({
        url: 'ffsapp-service/pasture/getPlayUrl',
        method: 'post',
        data: params
    })
}


//银行大屏-市场行情-列表
export function queryQuotationsList(params) {

    return request({
        url: 'xmbapp-service/quotations/list',
        method: 'post',
        data: params
    })
}
//银行大屏-市场行情-详情
export function queryQuotationsDetail(params) {

    return request({
        url: 'xmbapp-service/quotations/detailInfo',
        method: 'post',
        data: params
    })
}
